import { logger } from '@/utils/logger';
import { fetchUserProfile } from '@/services';
import { useSession } from '@zopauk/nextjs-auth';
import { useQuery } from '@tanstack/react-query';

export const useProfile = () => {
  const { data: session, status } = useSession();

  const profileQuery = useQuery({
    queryKey: ['profile', session?.user?.memberId],
    queryFn: fetchUserProfile,
    enabled: !!session,
  });

  if (profileQuery.error) {
    logger.error({
      message: `Failed to fetch user profile`,
      id: `[useProfile]: Error`,
      error: profileQuery.error,
      authenticated: status,
    });
  }

  return profileQuery;
};
